import Locale from '../../../translations';
export function BookYourGame() {
  const { messages } = Locale;
  return (
    <>
      <div className="pt-5">
        <h3 className="text-center">
          <img className="me-2" src="images/point.png" alt="img" /> {' '}{messages.bookYourGame}{' '}
          <img className="ms-2" src="images/point.png" alt="img" />
        </h3>
        <div className="row justify-content-around pt-5">
          <div className="col-lg-3 col-md-3 sm-6 text-md-center text-lg-center mb-3">
            <div className="d-md-block d-flex">
              <div className="bgImage">
                <img
                  src="images/Position.png"
                  className="img-fluid mx-auto d-block imageFixedHeight"
                  alt="img"
                />
              </div>
              <div>
                <h3 className="fw-bold pt-4 pt-lg-3">{messages.find}</h3>
                <p className="textSmall">{messages.aNearbyStadium}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 sm-6 text-md-center text-lg-center mb-3">
            <div className="d-md-block d-flex">
              <div className="bgImage">
                <img
                  src="images/calendar.png"
                  className="img-fluid mx-auto d-block imageFixedHeight"
                  alt="img"
                />
              </div>
              <div>
                <h3 className="fw-bold pt-4 pt-lg-3">{messages.select}</h3>
                <p className="textSmall">{messages.selectStadium}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 sm-6 text-md-center text-lg-center mb-3">
            <div className="d-md-block d-flex">
              <div className="bgImage">
                <img
                  src="images/Creditcard.png"
                  className="img-fluid mx-auto d-block imageFixedHeight"
                  alt="img"
                />
              </div>
              <div>
                <h3 className="fw-bold pt-4 pt-lg-3">{messages.pay}</h3>
                <p className="textSmall">{messages.bookingOnline}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
